export const rules ={
        title: [
        { required: true, message: "请输入场馆名!", trigger: "blur" },
      ],
      start_time: [
        { required: true, message: "开始日期!", trigger: "change" },
      ],
     
      end_time: [
        { required: true, message: "截至日期!", trigger: "change" },
      ],
      type: [
        { required: true, message: "请选择类型", trigger: "change" },
      ],
     
    }